<template>
  <div class="ad-root">
    <img :src="img" >
    <div class="btn-wrap">
      <div class="btn">
        <Button size="large" to="/vehicle" color="linear-gradient(to right, #4bb0ff, #6149f6)">点我续保</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img:require('../../assets/images/loans.png')
    }
  },
  created() {
    document.title = '车辆续保'
  }
}
</script>

<style lang="less" scoped>
.ad-root {
  position: relative;
  height: 100%;
  overflow: auto;
  img {
    width:100%;
  }
  .btn-wrap {
    // position: fixed;
    // bottom: 20px;
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: space-around;
    .btn {
      width: 80%;
      padding: 20px 10px;
    }
  }
}
</style>